/* batida-compat.js (8.10.2026, Horizon P0): what the copied v7 scripts expect from the old Pipeline theme.
   Plan 2.1: `theme:cart:change` is consumed by 54+ places in 30 Batida files, `theme:variant:change` by 8, `theme:cart:reload` by 5.
   Pipeline's theme.js fired them; Horizon fires its own events (@shopify/events: shopify:cart:lines-update, ...-discount-update,
   ...-note-update, shopify:product:select). This file re-dispatches them in the old shape so the Batida scripts run unchanged:
     - theme:cart:change  { detail: { cart: <Ajax cart JSON of /cart.js> } }  after every Horizon cart change and on pageshow
     - theme:variant:change { detail: { variant } } from Horizon's shopify:product:select (PDP, P3 to verify)
   One shared /cart.js read (concurrent requests are merged, 8 s deadline, one retry): window.batidaCart.read().
   Never fires on events that Batida scripts dispatch themselves (no loop: Horizon does not listen to theme:*).
   `theme:cart:reload` (Batida asks the theme to redraw cart lines/totals): a no-op on purpose (P4 checked: on live only Pipeline's theme.js listened; the Batida cart page and the slide-in cart redraw from theme:cart:change / their own reads, so nothing needs wiring).
   Stability (D9): every fetch has a deadline and a retry, failures are logged (console.warn) and never thrown. */
(function () {
  'use strict';
  if (window.__batidaCompat) return;
  window.__batidaCompat = true;

  var T = window.theme || {};
  var CART_URL = ((T.routes && T.routes.cart) || '/cart') + '.js';
  var inflight = null;

  function once() {
    var ctl = window.AbortController ? new AbortController() : null;
    var tm = setTimeout(function () { try { if (ctl) ctl.abort(); } catch (e) {} }, 8000);
    return fetch(CART_URL, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: ctl ? ctl.signal : undefined })
      .then(function (r) { clearTimeout(tm); if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); },
            function (e) { clearTimeout(tm); throw e; });
  }
  function read() {
    if (inflight) return inflight;
    inflight = once().catch(function () { return new Promise(function (r) { setTimeout(r, 400); }).then(once); });
    var clear = function () { setTimeout(function () { inflight = null; }, 150); };
    inflight.then(clear, clear);
    return inflight;
  }
  window.batidaCart = { read: read };

  function emit(cart, source) {
    try { document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart, source: source || 'horizon-compat' }, bubbles: true })); } catch (e) {}
  }
  function fromHorizon(e) {
    var p = e && e.promise;
    (p && p.then ? p.then(function () {}, function () {}) : Promise.resolve()).then(read).then(function (c) { emit(c, 'horizon'); })
      .catch(function (err) { console.warn('[batida-compat] cart read failed', err && err.message); });
  }
  ['shopify:cart:lines-update', 'shopify:cart:discount-update', 'shopify:cart:note-update'].forEach(function (n) {
    document.addEventListener(n, fromHorizon);
  });

  /* Pipeline's layout fired theme:cart:change on every pageshow (also the first load) - the Batida scripts rely on that first event */
  function onPageShow() {
    var go = function () { read().then(function (c) { emit(c, 'pageshow'); }).catch(function (err) { console.warn('[batida-compat] cart read failed', err && err.message); }); };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 500 }); else setTimeout(go, 0);
  }
  window.addEventListener('pageshow', onPageShow);

  /* theme:cart:reload (Batida scripts ask the theme to redraw cart lines/totals) is NOT answered with theme:cart:change here:
     some of those scripts dispatch it from their own theme:cart:change handler, which would loop. P4 connects it to the
     nothing: P4 verified that no Batida script listens for it (the live listener was Pipeline's theme.js), so it stays a documented no-op. */

  /* variants (PDP, P3): Horizon announces the chosen variant with shopify:product:select */
  document.addEventListener('shopify:product:select', function (e) {
    try {
      var d = e.detail || {};
      var v = d.variant || (d.product && d.product.selectedOrFirstAvailableVariant) || null;
      document.dispatchEvent(new CustomEvent('theme:variant:change', { detail: { variant: v, source: 'horizon' }, bubbles: true }));
    } catch (x) {}
  });
})();
